import React from 'react';
import { Link } from 'react-router-dom';

const Breadcrumb = ({ title, breadcrumbItems = [] }) => {
  // Default breadcrumb items if none provided
  const defaultItems = [
    { name: 'Home', path: '/' },
    { name: title, path: null, active: true }
  ];

  const items = breadcrumbItems.length > 0 ? breadcrumbItems : defaultItems;

  return (
    <div className="container-fluid bg-breadcrumb">
      <div className="container text-center py-5" style={{ maxWidth: '900px' }}>
        <h3 className="text-white display-3 mb-4 wow fadeInDown" data-wow-delay="0.1s">{title}</h3>
        <ol className="breadcrumb justify-content-center text-white mb-0 wow fadeInDown" style={{ background: 'none' }} data-wow-delay="0.3s">
          {items.map((item, index) => (
            <li key={index} className={`breadcrumb-item ${item.active ? 'active text-secondary' : ''}`}>
              {item.active ? (
                item.name
              ) : (
                <Link to={item.path} className="text-white">{item.name}</Link>
              )}
            </li>
          ))}
        </ol>    
      </div>
    </div>
  );
};

export default Breadcrumb; 